module.exports = __webpack_public_path__ + "static/img/1_1_1.38adfe51.jpg";